import { render } from "./GHomeTopBar.vue?vue&type=template&id=0aafdfff"
import script from "./GHomeTopBar.vue?vue&type=script&lang=js"
export * from "./GHomeTopBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__